import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as AddNewField } from 'assets/icons/Group 239993.svg';
import { ReactComponent as DeleteCost } from 'assets/icons/PendingIcon.svg';
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from 'components';
import Button from 'components/button/Button';
import InfoTooltip from 'components/InfoTooltip';
import AddInstallmentsPayment from 'components/Installments/AddInstallmentsPayment';
import PricingTabs from 'components/pricingTabs/PricingTabs';
import RadioButtons from 'components/RadioButtons/RadioButtons';
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper/dateFormat';
import { getCurrency, numberFormat } from 'helper/numberFormat';
import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import { toastr } from 'react-redux-toastr';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import FinanceService from '../../../../../Lib/API/Finance';
import './CostInfo.scss';
import LedgersMenu from './LedgersMenu';
import OptionalTypesItems from './OptionalTypesItems';
import PaymentTypeSelect from './PaymentTypeSelect';
import './Pricing.scss';
import { fontConfig } from "theme/fontConfig";

const PriceInfo = ({ formik }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [costActive, setCostActive] = useState(0);

  const orgDetails = getOrganizationInfoFromLocalStorage();
  const enableInstallments = orgDetails?.allowInstallments;

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const currency = getCurrency();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || 'mm/dd/yyyy');

  useEffect(() => {
    async function getLedgeraccounts() {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const res = await FinanceService.getLedgerSubLedgerList(token);
        if (res?.ledgers) {
          setLedgers(res?.ledgers);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const handleAddPrice = (title) => {
    formik.setFieldValue('prices', [
      ...formik.values?.prices,
      {
        title: title,
        amount: '',
        type: 'On Registration',
        ledger: {},
        subLedger: {},
        tax_deductible: '',
        tax_type: '$',
        chargeDate: '',
        dueDate: '',
        note: '',
        is_splitted: false,
        variant: false,
        quantity: '',
        infiniteQuantity: true,
        limitType: 'checkbox',
        variantInfo: [
          {
            name: '',
            quantity: '',
            infiniteQuantity: true,
            amount: '',
          }
        ],
      },
    ]);
  };

  const handleDeletePrice = (index) => {
    const prices = formik.values?.prices;
    prices.splice(index, 1);
    formik.setFieldValue('prices', prices);
  };

  const handleEditPrice = (index, newTitle) => {
    formik.setFieldValue(`prices[${index}].title`, newTitle);
  };

  const handleReorderPrices = (sourceIndex, destinationIndex) => {
    const prices = [...formik.values.prices];
    const [movedItem] = prices.splice(sourceIndex, 1);
    prices.splice(destinationIndex, 0, movedItem);
    formik.setFieldValue('prices', prices);
  };

  const checkDuplicatePrice = (title) => {
    return formik.values?.prices?.some(
      (item) => item?.title?.toLowerCase() === title.toLowerCase()
    );
  };

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }
  const exceptThisSymbols = ['e', 'E', '+', '-'];
  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };

  const checkAmountTitle = useCallback(type => {
    return type?.toLowerCase() === "optional" ? "Price" : "Amount";
  }, [])

  const acceptNumbersAndGtZero = (value) => {
    const updatedValue = parseInt(value) > 0 ? parseInt(value) : '';
    return updatedValue;
  };

  const removeVariantHandler = (index, variantIndex) => {
    const variants = formik.values?.prices?.[index]?.variantInfo;
    variants.splice(variantIndex, 1);
    formik.setFieldValue(`prices[${index}].variantInfo`, variants);
  };

  const resetVariantData = (index) => {
    formik.setFieldValue(`prices[${index}].quantity`, '');
    formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
  };

  const componentRender = (index) => {
    const allowInstallments = enableInstallments && formik.values?.prices?.[index]?.type !== 'No Payment Needed';

    return (
      <>
        <Row style={{ marginBottom: '20px' }}>
          <Col className="col-sm-6">
            <PaymentTypeSelect
              titleStyle={{
                fontFamily: fontConfig.GeneralPaymentTypeSelectFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
              title={'Type'}
              formik={formik}
              index={index}
              setCostActive={setCostActive}
              items={['On Registration', 'No Payment Needed', 'Optional', 'On Approval']}
              value={formik.values?.prices?.[index]?.type}
            />
          </Col>
          {(formik.values?.prices?.[index]?.type === 'Optional' && formik.values?.prices?.[index]?.variant) || (formik.values?.prices?.[index]?.type === 'No Payment Needed') ? null : (
            <Col className="col-sm-6">
              <InputField
                titleStyle={{
                  fontFamily: fontConfig.GeneralInputFieldFont.family,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                }}
                style={{ background: '#f6f6f6', color: '#002E5C' }}
                mandatory={true}
                formik={formik}
                title={checkAmountTitle(formik.values?.prices?.[index]?.type)}
                name={`prices[${index}].amount`}
                placeholder={checkAmountTitle(formik.values?.prices?.[index]?.type)}
                checkValidation={true}
                value={
                  formik.values?.prices?.[index]?.amount || ''
                }
                handleChange={(e) => {
                  const { value } = e.target;
                  const updatedValue = value.match(regex)[0] >= 1 ? value.match(regex)[0] : '';
                  if (parseFloat(updatedValue) > 1000000) return;
                  formik.setFieldValue(`prices[${index}].amount`, updatedValue);
                  if (!updatedValue) {
                    formik.setFieldError(`prices[${index}].amount`, 'Required');
                    formik.setFieldTouched(`prices[${index}].amount`, true);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
              />
            </Col>
          )}
        </Row>

        {formik.values?.prices?.[index]?.type === 'Optional' && (
          <Row style={{ marginBottom: '20px', alignItems: 'center' }}>
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <MyCheckbox
                  title="Has Variant"
                  name="variant"
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `prices[${index}].variant`,
                      e.target.checked
                    );
                    if (e.target.checked) {
                      formik.setFieldValue(`prices[${index}].quantity`, '');
                      formik.setFieldValue(`prices[${index}].infiniteQuantity`, false);
                      if (!formik.values?.prices?.[index]?.variantInfo?.length) {
                        formik.setFieldValue(`prices[${index}].variantInfo`, [{
                          name: '',
                          quantity: '',
                          infiniteQuantity: formik.values?.prices?.[index]?.limitType === 'checkbox',
                          amount: '',
                        }]);
                      }
                    }
                  }}
                  checked={formik.values?.prices?.[index]?.variant}
                />
                <InfoTooltip text="Create multiple options under this price, each with its own amount. E.g., 'Uniform - Small - $20', 'Uniform - Large - $25'." style={{ marginBottom: '8px' }} />
              </div>
            </Col>
            {formik.values?.prices?.[index]?.type === 'Optional' && (
              <Col className="col-sm-6">
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <RadioButtons
                    value={formik.values?.prices?.[index]?.limitType}
                    name={"limitType"}
                    onChange={(value) => {
                      formik.setFieldValue(
                        `prices[${index}].limitType`,
                        value
                      );
                      if (value === 'checkbox') {
                        resetVariantData(index);
                        const updatedVariants = (formik.values?.prices?.[index]?.variantInfo || []).map((v) => ({
                          ...v,
                          infiniteQuantity: true,
                          quantity: '',
                        }));
                        formik.setFieldValue(`prices[${index}].variantInfo`, updatedVariants);
                      }
                    }}
                    size={"small"}
                    row={true}
                    options={[
                      {
                        label: "Amount",
                        value: "amount"
                      },
                      {
                        label: "Checkbox",
                        value: "checkbox"
                      }
                    ]}
                  />
                  <InfoTooltip text="Use a checkbox for simple yes/no options, and an amount field when families need to select multiple units or quantities." style={{ marginBottom: '5px' }} />
                </div>
              </Col>
            )}
          </Row>
        )}
        {formik.values?.prices?.[index]?.type === 'Optional' && !formik.values?.prices?.[index]?.variant && (
          <Row style={{ marginBottom: '20px' }}>
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Quantity <span style={{ color: 'red' }}>*</span></label>
                <InfoTooltip text="Limit how many times this option can be selected across all registrations. E.g., Only 20 uniforms available. Leave blank or check No Limit for unlimited." />
              </div>
              <InputField
                titleStyle={{
                  fontFamily: fontConfig.GeneralInputFieldFont.family,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                }}
                style={{ background: '#f6f6f6', color: '#002E5C' }}
                formStyle={{ marginBottom: 0 }}
                mandatory={true}
                formik={formik}
                title="none"
                name={`prices[${index}].quantity`}
                placeholder="Quantity"
                checkValidation={true}
                value={
                  formik.values?.prices?.[index]?.quantity
                }
                handleChange={(e) => {
                  const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)[0]);
                  if (parseFloat(value) > 10000) return;
                  formik.setFieldValue(`prices[${index}].quantity`, value);
                  if (!value) {
                    formik.setFieldError(`prices[${index}].quantity`, 'Required');
                    formik.setFieldTouched(`prices[${index}].quantity`, true);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                disabled={formik.values?.prices?.[index]?.infiniteQuantity || formik.values?.prices?.[index]?.limitType === 'checkbox'}
              />
            </Col>
            <Col className="col-sm-6">
              <div style={{ visibility: 'hidden', marginBottom: '4px' }}>
                <label style={{ fontSize: '12px' }}>placeholder</label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', height: '48px' }}>
              <MyCheckbox
                title="No Limit"
                name="infiniteQuantity"
                checked={!!formik.values?.prices?.[index]?.infiniteQuantity}
                handlechange={(e) => {
                  formik.setFieldValue(
                    `prices[${index}].infiniteQuantity`,
                    e.target.checked
                  );
                  if (e.target.checked) {
                    formik.setFieldValue(
                      `prices[${index}].quantity`,
                      ''
                    );
                  }
                }}
                disabled={formik.values?.prices?.[index]?.limitType === 'checkbox'}
              />
              </div>
            </Col>
          </Row>
        )}
        {formik.values?.prices?.[index]?.type === 'Optional' && formik.values?.prices?.[index]?.variant && (
          <>
            {formik.values?.prices?.[index]?.variantInfo?.map((item, variantIndex) => (
              <React.Fragment key={variantIndex}>
                {variantIndex > 0 && (
                  <hr style={{ borderTop: '1px dashed rgba(0, 46, 92, 0.3)', margin: '0 0 16px 0' }} />
                )}
                <OptionalTypesItems
                  formik={formik}
                  index={index}
                  variantIndex={variantIndex}
                  removeVariantHandler={removeVariantHandler}
                  acceptNumbersAndGtZero={acceptNumbersAndGtZero}
                />
              </React.Fragment>
            ))}
            <Row style={{ marginBottom: '20px' }}>
              <Col className="col-sm-12">
                <button className="optional_type_add_btn" onClick={() => {
                  const variants = formik.values?.prices?.[index]?.variantInfo || [];
                  let hasIncomplete = false;
                  variants.forEach((v, vi) => {
                    if (!v?.name) {
                      formik.setFieldError(`prices[${index}].variantInfo[${vi}].name`, 'Required');
                      formik.setFieldTouched(`prices[${index}].variantInfo[${vi}].name`, true);
                      hasIncomplete = true;
                    }
                    if (!v?.amount) {
                      formik.setFieldError(`prices[${index}].variantInfo[${vi}].amount`, 'Required');
                      formik.setFieldTouched(`prices[${index}].variantInfo[${vi}].amount`, true);
                      hasIncomplete = true;
                    }
                    if (!v?.infiniteQuantity && !v?.quantity) {
                      formik.setFieldError(`prices[${index}].variantInfo[${vi}].quantity`, 'Required');
                      formik.setFieldTouched(`prices[${index}].variantInfo[${vi}].quantity`, true);
                      hasIncomplete = true;
                    }
                  });
                  if (hasIncomplete) {
                    toastr.info('Incomplete Variants', 'Please fill in all required fields in existing variants before adding a new one.');
                    return;
                  }
                  formik.setFieldValue(`prices[${index}].variantInfo`, [...variants, {
                    name: '',
                    quantity: '',
                    infiniteQuantity: formik.values?.prices?.[index]?.limitType === 'checkbox',
                    amount: '',
                  }])
                }}>
                  <AddNewField />
                  Add
                </button>
              </Col>
            </Row>
          </>
        )}
        {formik.values?.prices?.[index]?.type === 'Optional' && (
          <Row style={{ marginBottom: '20px' }}>
            <Col className="col-sm-12">
              <hr
                className="w-100 mb-5"
                style={{ borderBottom: 'dashed 1px #002E5C', opacity: '0.2' }}
              />
            </Col>
          </Row>
        )}

        {formik.values?.prices?.[index]?.type !== 'No Payment Needed' && (
          <Row style={{ marginBottom: '20px' }}>
            <Col className="col-sm-6">
              <LabelField
                mandatory
                title="Ledgers"
                titleStyle={{
                  fontFamily: fontConfig.GeneralLabelFieldFont.family,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                  margin: '0px',
                }}
              />
              <LedgersMenu
                ledgers={ledgers}
                formik={formik}
                index={index}
                loading={loading}
                hasError={!!(formik.touched?.prices?.[index]?.ledger && formik.errors?.prices?.[index]?.ledger)}
              />
            </Col>
            <Col className="col-sm-6">
              <div className="class_tax_deductible">
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: '400',
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#4F4F4F',
                  }}
                  style={{ background: '#f6f6f6', color: '#002E5C' }}
                  formik={formik}
                  title="Tax Deductible"
                  name="tax_deductible"
                  placeholder="Tax Deductible"
                  checkValidation={true}
                  value={formik.values?.prices?.[index]?.tax_deductible ?? ''}
                  handleChange={(e) => {
                    const val = e.target.value.match(regex)[0];
                    const maxVal = formik.values?.prices?.[index]?.tax_type === '%' ? 100 : 10000;
                    if (parseFloat(val) > maxVal) return;
                    formik.setFieldValue(`prices[${index}.tax_deductible]`, val);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
                <div className="tax_type">
                  <span
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].tax_type`, '$');
                      formik.setFieldValue(`prices[${index}].tax_deductible`, '');
                    }}
                    className={
                      formik.values?.prices?.[index]?.tax_type === '$'
                        ? 'text-primary tax_type_selected'
                        : ''
                    }
                  >
                    {currency}
                  </span>
                  <span>|</span>
                  <span
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].tax_type`, '%');
                      formik.setFieldValue(`prices[${index}].tax_deductible`, '');
                    }}
                    className={
                      formik.values?.prices?.[index]?.tax_type === '%'
                        ? 'text-primary tax_type_selected'
                        : ''
                    }
                  >
                    %
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        )}
        {formik.values?.prices?.[index]?.type === 'On Approval' && (
          <Row style={{ marginBottom: '20px' }}>
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <LabelField title={'Charge Date'} mandatory style={{ marginBottom: 0 }} />
                <InfoTooltip text="The date this charge is billed to the account, once approved." style={{ marginBottom: '8px' }} />
              </div>
              <DatePicker
                isClearable
                showIcon
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                selected={
                  formik.values?.prices?.[index]?.chargeDate &&
                  // new Date(formik?.values?.date_of_death)
                  convertUTCToLocalDate(
                    formik.values?.prices?.[index]?.chargeDate
                  )
                }
                onChange={(e) => {
                  formik.setFieldValue(`prices[${index}.chargeDate]`, e);
                  convertLocalToUTCDate(e, `prices[${index}.chargeDate]`);
                  if (!e) {
                    formik.setFieldError(`prices[${index}].chargeDate`, 'Required');
                    formik.setFieldTouched(`prices[${index}].chargeDate`, true);
                  }
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateMask}
                    keepCharPositions={true}
                    guide={true}
                    className={`form-control form-control-solid${formik.touched?.prices?.[index]?.chargeDate && formik.errors?.prices?.[index]?.chargeDate ? ' is-invalid' : ''}`}
                  />
                }
              />
              {formik.touched?.prices?.[index]?.chargeDate && formik.errors?.prices?.[index]?.chargeDate && (
                <HintField error={formik.errors.prices[index].chargeDate} />
              )}
            </Col>
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <LabelField title={'Due Date'} mandatory style={{ marginBottom: 0 }} />
                <InfoTooltip text="The date this charge is due to be paid by." style={{ marginBottom: '8px' }} />
              </div>
              <DatePicker
                isClearable
                showIcon
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                selected={
                  formik.values?.prices?.[index]?.dueDate &&
                  convertUTCToLocalDate(formik.values?.prices?.[index]?.dueDate)
                }
                onChange={(e) => {
                  formik.setFieldValue(`prices[${index}].dueDate`, e);
                  convertLocalToUTCDate(e, `prices[${index}].dueDate`);
                  if (!e) {
                    formik.setFieldError(`prices[${index}].dueDate`, 'Required');
                    formik.setFieldTouched(`prices[${index}].dueDate`, true);
                  }
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateMask}
                    keepCharPositions={true}
                    guide={true}
                    className={`form-control form-control-solid${formik.touched?.prices?.[index]?.dueDate && formik.errors?.prices?.[index]?.dueDate ? ' is-invalid' : ''}`}
                  />
                }
              />
              {formik.touched?.prices?.[index]?.dueDate && formik.errors?.prices?.[index]?.dueDate && (
                <HintField error={formik.errors.prices[index].dueDate} />
              )}
            </Col>
          </Row>
        )}
        <Row style={{ marginBottom: '20px' }}>
          <Col className="col-sm-12">
            <InputField
              titleStyle={{
                fontFamily: fontConfig.GeneralInputFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
              style={{ background: '#f6f6f6', color: '#002E5C' }}
              formik={formik}
              mandatory={formik.values?.prices?.[index]?.required_notes ?? false}
              title="Note"
              name="note"
              placeholder="Note"
              checkValidation={true}
              value={formik.values?.prices?.[index]?.note ?? ''}
              handleChange={(e) => {
                if (e.target.value.length > 200) return;
                formik.setFieldValue(`prices[${index}].note`, e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
            />
          </Col>
        </Row>
        <hr
          className="w-100 mb-5"
          style={{ borderBottom: 'dashed 1px #002E5C', opacity: '0.2' }}
        />
        <div className="d-flex" style={{ gap: '20px' }}>
          {formik.values?.prices?.[index]?.type === 'On Approval' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MyCheckbox
                title="Split Charge"
                name="split_charge"
                handlechange={(e) => {
                  formik.setFieldValue(
                    `prices[${index}].is_splitted`,
                    e.target.checked
                  );
                  formik.setFieldValue(
                    `prices[${index}].isInstallmentTransaction`,
                    false
                  );
                }}
                checked={formik.values?.prices?.[index]?.is_splitted}
                disabled={formik.values?.prices?.[index]?.type !== 'On Approval'}
              />
              <InfoTooltip text={<>Break this <b>charge</b> into multiple payments spread over time, instead of billing the full amount at once.</>} style={{ marginBottom: '8px' }} />
            </div>
          )}
          {allowInstallments && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MyCheckbox
                title="Allow Installments"
                name="isInstallmentTransaction"
                handlechange={(e) => {
                  formik.setFieldValue(
                    `prices[${index}].isInstallmentTransaction`,
                    e.target.checked
                  );
                  formik.setFieldValue(
                    `prices[${index}].is_splitted`,
                    false
                  );
                }}
                checked={formik.values?.prices?.[index]?.isInstallmentTransaction || false}
              />
              <InfoTooltip text="Let the payer spread this charge across multiple scheduled installments instead of paying it all at once." style={{ marginBottom: '8px' }} />
            </div>
          )}
        </div>
        {(formik.values.prices[index]?.isInstallmentTransaction && allowInstallments) && (
          <AddInstallmentsPayment
            formik={formik}
            formikKey={`prices[${index}].installmentDetailsTransaction`}
            onInstallmentChange={(value) => {
              if (!value) {
                formik.setFieldValue(`prices.${index}.installmentDetailsTransaction.numberOfInstallment`, null);
                formik.setFieldError(`prices[${index}].installmentDetailsTransaction.numberOfInstallment`, 'Required');
                formik.setFieldTouched(`prices[${index}].installmentDetailsTransaction.numberOfInstallment`, true);
                return;
              }
              formik.setFieldValue(`prices.${index}.installmentDetailsTransaction.numberOfInstallment`, value?.value);
            }}
            onDateChange={(date) => {
              formik.setFieldValue(`prices.${index}.installmentDetailsTransaction.lastInstallmentDate`, date);
              convertLocalToUTCDate(date, `prices.${index}.installmentDetailsTransaction.lastInstallmentDate`);
              if (!date) {
                formik.setFieldError(`prices[${index}].installmentDetailsTransaction.lastInstallmentDate`, 'Required');
                formik.setFieldTouched(`prices[${index}].installmentDetailsTransaction.lastInstallmentDate`, true);
              }
            }}
            installmentValue={formik.values.prices[index]?.installmentDetailsTransaction?.numberOfInstallment}
            dateValue={
              formik.values.prices[index]?.installmentDetailsTransaction?.lastInstallmentDate &&
              convertUTCToLocalDate(formik.values.prices[index]?.installmentDetailsTransaction?.lastInstallmentDate)
            }
            manageFromOutside={true}
          />
        )}
        {formik.values?.prices?.[index]?.is_splitted && (
          <Row>
            <div className="col-sm-5">
              <SelectField
                {...{
                  formik,
                  name: `values.${index}.split_duration`,
                  items: ['day', 'week', 'month', 'quarter', 'year'],
                  placeholder: 'Select',
                  value: formik.values?.prices?.[index]?.split_duration ? (
                    <span style={{ color: 'black' }}>
                      {formik.values?.prices?.[index]?.split_duration}
                    </span>
                  ) : (
                    'Select'
                  ),
                }}
                onClick={(data) =>
                  formik.setFieldValue(`prices[${index}].split_duration`, data)
                }
              />
            </div>
            {formik.values?.prices?.[index]?.split_duration ? (
              <div className="col-sm-3">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: '',
                    name: `values.${index}.number_of_split`,
                    placeholder: '0',
                    value: formik.values?.prices?.[index]?.number_of_split,
                    checkValidation: true,
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  handleChange={(e) =>
                    formik.setFieldValue(
                      `prices[${index}].number_of_split`,
                      e.target.value
                    )
                  }
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
                {/* <div className="placeholder-div">
                  <p>{formik.values.values?.[index]?.split_amount}</p>
                </div> */}
              </div>
            ) : (
              ''
            )}
          </Row>
        )}
      </>
    );
  };
  const total = formik.values?.prices?.reduce(
    (acc, item) => acc + Number(item.amount),
    0
  );
  return (
    <div className="cost_info_container">
      <div className="cost_info_left_side">
        <div className="cost_info_title">
          <PricingTabs
            items={formik.values?.prices || []}
            activeTab={costActive}
            setActiveTab={setCostActive}
            onAdd={handleAddPrice}
            onBeforeAdd={() => {
              const prices = formik.values?.prices || [];
              let hasIncomplete = false;
              prices.forEach((p, i) => {
                if (!p?.type) {
                  formik.setFieldError(`prices[${i}].type`, 'Required');
                  formik.setFieldTouched(`prices[${i}].type`, true);
                  hasIncomplete = true;
                }
                if (p?.type === 'No Payment Needed') return;
                if (!p?.ledger || JSON.stringify(p.ledger) === '{}') {
                  formik.setFieldError(`prices[${i}].ledger`, 'Required');
                  formik.setFieldTouched(`prices[${i}].ledger`, true);
                  hasIncomplete = true;
                }
                if (p?.type === 'Optional') {
                  if (p.variant) {
                    (p.variantInfo || []).forEach((v, vi) => {
                      if (!v?.name) {
                        formik.setFieldError(`prices[${i}].variantInfo[${vi}].name`, 'Required');
                        formik.setFieldTouched(`prices[${i}].variantInfo[${vi}].name`, true);
                        hasIncomplete = true;
                      }
                      if (!v?.amount) {
                        formik.setFieldError(`prices[${i}].variantInfo[${vi}].amount`, 'Required');
                        formik.setFieldTouched(`prices[${i}].variantInfo[${vi}].amount`, true);
                        hasIncomplete = true;
                      }
                      if (!v?.infiniteQuantity && !v?.quantity) {
                        formik.setFieldError(`prices[${i}].variantInfo[${vi}].quantity`, 'Required');
                        formik.setFieldTouched(`prices[${i}].variantInfo[${vi}].quantity`, true);
                        hasIncomplete = true;
                      }
                    });
                  } else {
                    if (!p.amount) {
                      formik.setFieldError(`prices[${i}].amount`, 'Required');
                      formik.setFieldTouched(`prices[${i}].amount`, true);
                      hasIncomplete = true;
                    }
                    if (!p.infiniteQuantity && p.limitType === 'amount' && !p.quantity) {
                      formik.setFieldError(`prices[${i}].quantity`, 'Required');
                      formik.setFieldTouched(`prices[${i}].quantity`, true);
                      hasIncomplete = true;
                    }
                  }
                } else {
                  if (!p.amount) {
                    formik.setFieldError(`prices[${i}].amount`, 'Required');
                    formik.setFieldTouched(`prices[${i}].amount`, true);
                    hasIncomplete = true;
                  }
                  if (p?.type === 'On Approval') {
                    if (!p.chargeDate) {
                      formik.setFieldError(`prices[${i}].chargeDate`, 'Required');
                      formik.setFieldTouched(`prices[${i}].chargeDate`, true);
                      hasIncomplete = true;
                    }
                    if (!p.dueDate) {
                      formik.setFieldError(`prices[${i}].dueDate`, 'Required');
                      formik.setFieldTouched(`prices[${i}].dueDate`, true);
                      hasIncomplete = true;
                    }
                  }
                }
              });
              if (hasIncomplete) {
                toastr.info('Incomplete Prices', 'Please fill in all required fields in existing prices before adding a new one.');
                return false;
              }
              return true;
            }}
            onDelete={handleDeletePrice}
            onEdit={handleEditPrice}
            onReorder={handleReorderPrices}
            duplicateCheck={checkDuplicatePrice}
            titleKey="title"
            minItems={0}
            hasError={(index) => {
              const e = formik.errors?.prices?.[index];
              return !!(e && Object.keys(e).some((k) => {
                if (k === 'variantInfo') return Array.isArray(e.variantInfo) && e.variantInfo.some((v) => v && Object.keys(v).length > 0);
                if (k === 'installmentDetailsTransaction') return e.installmentDetailsTransaction && Object.keys(e.installmentDetailsTransaction).length > 0;
                return !!e[k];
              }));
            }}
          />
        </div>
        <div class="vertical-line"></div>
      </div>
      <div className="cost_info_content">
        {formik.values?.prices?.length > 0 ? (
          componentRender(costActive)
        ) : (
          <div className="no_cost text-center">No Cost Found</div>
        )}
      </div>
    </div>
  );
};

export default PriceInfo;
